// @flow
import React from "react"
import { TransitionMotion, spring } from "react-motion"

const willEnter = () => {
  return {
    opacity: 0,
    x: 100,
  }
}

const willLeave = () => {
  return {
    opacity: spring(0),
    x: spring(-100),
  }
}

const getStyles = () => {
  return {
    opacity: spring(1),
    x: spring(0),
  }
}

type Props = {
  children: any,
  current: number | string,
}

const Transition = ({ children, current }: Props) => (
  <div css={styles.wrapper}>
    <TransitionMotion
      styles={[
        {
          key: `${current}`,
          style: getStyles(),
          data: { children },
        },
      ]}
      willEnter={willEnter}
      willLeave={willLeave}
    >
      {interpolated => (
        <div>
          {interpolated.map(({ key, style, data }) => (
            <div
              key={key}
              css={styles.inner}
              style={{
                opacity: style.opacity,
                WebkitTransform: `translateX(${style.x}%)`,
                transform: `translateX(${style.x}%)`,
              }}
            >
              {data.children}
            </div>
          ))}
        </div>
      )}
    </TransitionMotion>
  </div>
)

const styles = {
  wrapper: {
    position: "relative",
    width: "100%",
    height: "100%",
  },
  inner: {
    position: "absolute",
    width: "100%",
    top: "0",
  },
}

export default Transition



// WEBPACK FOOTER //
// ./src/components/Transition.js